import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BaseApiService } from '@prv/apis';
import * as i1 from '@angular/common/http';
import * as i2 from '@nexa/configuration';

/**
 * Representa los datos obtenidos del web service
 */
class DataSegmenterDto {
}

/**
 * Representa la información que se emite desde medios externos
 */
class DataExternalDto {
}

/**
 * Clase que contiene el servicio de segmentador
 */
class SegmenterApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see SegmenterApiService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'segmenter', 'Segmenter');
    }
    /**
     * Método encargado de consultar el web service segmentador y retornar la información
     * @param args Argumentos para la ejecucion del servicio
     * @returns Objeto de tipo @see DataSegmenterDto con la información del segmentador
     * @example
     */
    getSegmenterData(args) {
        return this.getUri((uri) => this.httpClient.post(`${uri}/GetSegmenterData`, args));
    }
    /**
     * Método encargado de consultar el web service segmentador y retornar la información
     * para aplicaciones externas
     * @param data Argumentos para la ejecucion del servicio
     * @returns Objeto de tipo @see DataExternalDto con la información del segmentador serializada y encriptada
     * @example
     */
    getSegmenterDataExternal(data) {
        return this.getUri((uri) => this.httpClient.post(`${uri}/GetSegmenterDataExternal`, data));
    }
}
SegmenterApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: SegmenterApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
SegmenterApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: SegmenterApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: SegmenterApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/*
 * Public API Surface of ws-segmenter
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DataExternalDto, DataSegmenterDto, SegmenterApiService };
